/**
 * @param {string} svg
 * @returns {string}
 */
const getSvgDataURI = svg =>
    `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;

export default getSvgDataURI;
